// ======================================================================
// File Name       : DistributionReportAssignmentContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Col } from 'react-bootstrap';
import moment from 'moment';
import ModalWrapper from '../../../components/modal/ModalWrapper';
import * as modalActions from '../../../actions/ModalAction';
import RenderField from '../../../utils/ReduxFormUtils';
import DialogConfirm from '../../../components/DialogConfirm';
import * as MessageTemplate from '../../../constants/MessageTemplate';
import UserSearch from '../../../components/report/distribution/UserSearch';
import UserList from '../../../components/report/distribution/UserList';
import * as distributionAction from '../../../actions/report/DistributionAction';
import { REPORT_OPERATION_TYPE } from '../../../constants/KeyValueConstants';
import { randomArray, isSuperUser } from '../../../utils/index';
import {
  DEFAULT_DATE_FROM,
  DEFAULT_DATE_TO,
  DEFAULT_DATE_TO_TEXT,
  DEFAULT_DATE_FROM_TEXT,
  DEFAULT_DATE_FORMAT,
} from '../../../constants/index';
import { getUserGroupRelation } from '../../../actions/UserAction';

class DistributionReportAssignmentContainer extends Component {
  constructor() {
    super();
    this.state = {
      showModalConfirm: false,
      showSelectGroup: false,
      showModalSuccessUpdate: false,
      selectedReportNum: 0,
    };
    this.onConfirmDialogCancelBtnClick = this.onConfirmDialogCancelBtnClick.bind(this);
    this.onConfirmDialogOkBtnClick = this.onConfirmDialogOkBtnClick.bind(this);
    this.onSuccessDialogOkBtnClick = this.onSuccessDialogOkBtnClick.bind(this);
  }

  componentWillMount() {
    const { dispatch } = this.props;
    dispatch(distributionAction.initDistributionReportDetail());
  }

  openConfirmDialog(mdContent, mdSize) {
    this.content = mdContent;
    this.mdSize = mdSize;
    this.setState({ showModalConfirm: true });
  }

  onConfirmDialogCancelBtnClick() {
    this.setState({ showModalConfirm: false });
  }

  onConfirmDialogOkBtnClick() {
    this.setState({ showModalConfirm: false });
    this.updateDistributionReport();
  }

  getModalOptions() {
    const { selectedReportNum } = this.state;
    return {
      title: '',
      footerBtns: [
        { name: 'キャンセル', onClick: this.props.hideModal, variant: 'default' },
        { name: '分配',
          onClick: this.openConfirmDialog.bind(this, MessageTemplate.DISTRIBUTE_REPORT, null),
          variant: 'primary',
          disabled: (selectedReportNum <= 0) },
      ],
    };
  }

  componentWillReceiveProps(nextProps) {
    const { distributionReport, user } = nextProps;
    const { distributionReportDetail } = distributionReport;
    const { updateResult, searchInfo, userListInfo } = distributionReportDetail;
    let selectedReportNum = 0;
    userListInfo && userListInfo.length > 0 && userListInfo.forEach((item) => {
      selectedReportNum += item.distributionReportNum ? parseInt(item.distributionReportNum, 10) : 0;
    });
    this.setState({ showSelectGroup: searchInfo.showSelectGroup, selectedReportNum });
    if (updateResult.reportList && updateResult.reportList.length > 0) {
      this.openSuccessDialog(MessageTemplate.DISTRIBUTE_REPORT_COMPLETE);
      this.props.dispatch(distributionAction.clearUpdateResult());
    }
  }

  componentWillUnmount() {
    this.props.dispatch(distributionAction.resetDistributionReportAssignment());
  }

  openSuccessDialog(mdContent) {
    this.content = mdContent;
    this.setState({ showModalSuccessUpdate: true });
  }

  onSuccessDialogOkBtnClick() {
    this.setState({ showModalSuccessUpdate: false });
    this.props.hideModal();
  }

  updateDistributionReport() {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { distributionEdittingReport, userListInfo } = distributionReportDetail;
    const { itemLearningHistoryReportIdList } = distributionEdittingReport;
    const reportListAuthorize = [];
    if (userListInfo && userListInfo.length > 0) {
      userListInfo.forEach((item) => {
        // random list report by distribution num
        const distributionNum = item.distributionReportNum || 0;
        // todo: need change by random function
        const reportIdList = randomArray(itemLearningHistoryReportIdList, distributionNum);
        reportIdList.forEach((id) => {
          const reportAuthorize = {
            itemLearningHistoryReportIdAuto: id,
            checkerUserSecernId: item.userSecernId,
          };
          reportListAuthorize.push(reportAuthorize);
          const index = itemLearningHistoryReportIdList.indexOf(id);
          itemLearningHistoryReportIdList.splice(index, 1);
        });
      });
    }
    const param = {
      reportOperationType: REPORT_OPERATION_TYPE.REPORT_OPERATION_TYPE_DISTRIBUTION,
      reportListAuthorize,
    };
    this.props.dispatch(distributionAction.updateDistributionReportByCorrector(param));
  }

  render() {
    const { dispatch, distributionReport } = this.props;
    const { distributionReportDetail } = distributionReport;
    const { distributionEdittingReport, searchInfo, userListInfo } = distributionReportDetail;
    const {
      reportNum,
      reportDeadline,
      reportReturnPlanDate,
      reportName,
        } = distributionEdittingReport;
    const { showModalConfirm, showModalSuccessUpdate, showSelectGroup } = this.state;
    const reportDeadlineTemp = reportDeadline ?
      (moment(reportDeadline).format(DEFAULT_DATE_FORMAT) === DEFAULT_DATE_TO
        ? DEFAULT_DATE_TO_TEXT
        : moment(reportDeadline).format(DEFAULT_DATE_FORMAT)) : '';

    const reportReturnPlanDateTemp = reportReturnPlanDate ?
      (moment(reportReturnPlanDate).format(DEFAULT_DATE_FORMAT) === DEFAULT_DATE_FROM
        ? DEFAULT_DATE_FROM_TEXT
        : moment(reportReturnPlanDate).format(DEFAULT_DATE_FORMAT)) : '';
    return (
      <div>
        <ModalWrapper
          temporaryHide={(showModalConfirm || showModalSuccessUpdate || showSelectGroup) ? 'hidden' : ''}
          {...this.getModalOptions()}
          hideModal={this.props.hideModal}
        >
          <div>
            <Col sm={12} className="line-border-bottom">
              <Form className='form-horizontal'>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    レポート名
                  </Col>
                  <Col as={Form.Label} sm={9}>
                    {reportName}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    提出期限
                  </Col>
                  <Col as={Form.Label} sm={9}>
                    {reportDeadlineTemp}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    結果返却予定日
                  </Col>
                  <Col as={Form.Label} sm={9}>
                    {reportReturnPlanDateTemp}
                  </Col>
                </Form.Group>
                <Form.Group className="form-info">
                  <Col as={Form.Label} sm={3}>
                    未分配レポート件数
                  </Col>
                  <Col as={Form.Label} sm={9}>
                    {reportNum !== undefined ? `${reportNum}件` : ''}
                  </Col>
                </Form.Group>
              </Form>
            </Col>
            <UserSearch />
            <UserList />
          </div>
        </ModalWrapper>
        <DialogConfirm
          showModal={this.state.showModalConfirm}
          onCancel={this.onConfirmDialogCancelBtnClick}
          mdSize={this.mdSize}
          content={this.content}
          onOK={this.onConfirmDialogOkBtnClick}
        />
        <DialogConfirm
          showModal={this.state.showModalSuccessUpdate}
          content={this.content}
          onOK={this.onSuccessDialogOkBtnClick}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { distributionReport } = state;
  const { authedUser } = state.authed;
  return {
    distributionReport,
    authedUser,
  };
};

export default connect(mapStateToProps)(DistributionReportAssignmentContainer);
